export default "__VITE_ASSET__Ca5QXa0I__"